import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {TerminalEmail} from "@portbase/bezoekschip-service-typescriptmodels";

@Component({
    selector: 'app-edit-terminal-email',
    templateUrl: './edit-terminal-email.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditTerminalEmailComponent {
  @Input() terminalEmail : TerminalEmail;
}
